import * as Sentry from "@sentry/sveltekit";

export function setupSentryReplay(){
    import("@sentry/sveltekit").then((lazyLoadedSentry) => {
        Sentry.addIntegration(lazyLoadedSentry.replayIntegration());
    });
}